<template>
	<div class="shopGroup_details">
		<!-- 商品头部状态 -->
		<div class="header">
			<div class="bgc mb-10" v-if="shopDetailObj.cooperate_status === 2">
				<div v-if="deliveryInfo.is_refuse_delivery == refuseDelivery.no">
					<p class="yx-color-text-primary">
						<span>{{ deliveryInfo.delivery_status_desc }}</span>
						<span class="yx-color-text-regular fz-14 ml-20">{{ deliveryInfo.delivery_time }}</span>
					</p>
					<p class="yx-color-text-regular flex flex-just-between mt-6 fz-14" v-if="deliveryInfo.delivery_status != deliveryStatus.notShipped">
						<span>{{ deliveryInfo.delivery_logistics.length ? deliveryInfo.delivery_logistics[0].context : '' }}</span>
						<span class="primary" @click="detalis">快递详情</span>
					</p>
					<p class="yx-color-text-regular mt-6 fz-14" v-if="deliveryInfo.delivery_status != deliveryStatus.notShipped">
						<span>{{ deliveryInfo.shipping_company }}</span>
						<span class="ml-20">快递单号：</span>
						<span class="ml-10">{{ deliveryInfo.shipping_sn }}</span>
					</p>
					<p class="yx-color-text-regular mt-6 fz-14" v-if="deliveryInfo.delivery_status == deliveryStatus.notShipped">
						<span>该商品暂未发货，请尽快联系商家发货</span>
					</p>
					<p class="yx-color-text-regular mt-6 fz-14" v-if="deliveryInfo.delivery_status == deliveryStatus.notShipped">
						<span>(暂无快递信息)</span>
					</p>
				</div>
				<div v-else>
					<p class="yx-color-text-primary">
						<span>拒绝发货</span>
					</p>
					<p class="yx-color-text-regular mt-6 fz-14" v-if="deliveryInfo.delivery_status == deliveryStatus.notShipped">
						<span>拒绝原因：{{ deliveryInfo.refuse_delivery_content }}</span>
					</p>
				</div>
			</div>
			<div class="bgc mb-20" v-if="shopDetailObj.cooperate_status === 3">
				<p
					:class="{
						warning: live_info.url_check_status == linkStatus.toboUp || live_info.url_check_status == linkStatus.tobeCheck,
						default: live_info.url_check_status == linkStatus.finished,
					}"
				>
					{{ live_info.url_check_status_desc }}
				</p>
				<p class="yx-color-text-regular fz-14 mt-10">
					<span>预计开播时间：</span>
					<span>{{ live_info.estimate_time }}</span>
				</p>
			</div>
			<div v-if="shopDetailObj.cooperate_status === 4">
				<div class="bgc mb-10">
					<p
						:class="{
							success: live_info.cooperate_status == cooperationStatus.ongoing,
							default: live_info.cooperate_status == cooperationStatus.end,
						}"
					>
						{{ live_info.cooperate_status_desc }}
					</p>
					<p class="yx-color-text-regular fz-14 mt-10">开始合作时间：{{ live_info.cooperate_start_time }}</p>
					<p class="yx-color-text-regular fz-14 mt-10" v-if="live_info.cooperate_status == cooperationStatus.end">
						合作结束时间：{{ live_info.cooperate_end_time }}
					</p>
				</div>
				<div class="bgc mb-20">
					<div class="yx-color-text-primary">本次合作战报</div>
					<div class="flex mt-10">
						<p class="mr-30">
							<span class="fz-14 yx-color-text-regular">预估销量(件)</span>
							<span class="yx-color-text-primary font-bold ml-6">{{ shopDetailObj.total_num }}</span>
						</p>
						<p class="mr-30">
							<span class="fz-14 yx-color-text-regular">预估销售额(元)</span>
							<span class="yx-color-text-primary font-bold ml-6">{{ shopDetailObj.total_pay_amount }}</span>
						</p>
					</div>
				</div>
			</div>
			<logistics ref="logistics"></logistics>
		</div>
		<!-- 商品详情 -->
		<shop-details :shopDetailObj="shopDetailObj"></shop-details>
		<!-- 商品底部按钮 -->
		<div class="footer-btn">
			<p
				class="cor-FA8F14 tips flex flex-just-center flex-align-center"
				v-if="shopDetailObj.promote_status === promoteStatus.close || shopDetailObj.product_status === productStatus.down"
			>
				商品暂停推广或下架
			</p>
			<div v-else>
				<p class="cor-FA8F14 tips flex flex-just-center flex-align-center" v-if="shopDetailObj.is_change == changeStatus.yes && isDarenPartner">
					该商品的机制已发生变更，请重新确认机制
				</p>
			</div>

			<div class="flex button flex-just-center flex-align-center">
				<el-button @click="lookCard(shopDetailObj)" v-if="isLookCard(shopDetailObj)">查看手卡</el-button>
				<el-button type="primary" @click="multiFun(shopDetailObj, 2, tabName, shopDetailObj?.platform_id)" v-if="isRemove(shopDetailObj)">
					移除选品表
				</el-button>
				<!-- <el-button type="primary" :disabled="true">已申请样品</el-button> -->
				<el-button type="primary" @click="applyFun(shopDetailObj, tabName)" v-if="isApply(shopDetailObj)">申请样品</el-button>
				<el-button type="primary" @click="changeDFun(shopDetailObj, tabName)" v-if="isChange(shopDetailObj)">查看变更详情</el-button>
				<!-- 待播移除 -->
				<el-button type="primary" @click="multiFun(shopDetailObj, 1, tabName, shopDetailObj?.platform_id)" v-if="isDel(shopDetailObj)">
					移除商品
				</el-button>
				<!-- 申样移除 -->
				<el-button type="primary" @click="multiFun(shopDetailObj, 8, tabName, shopDetailObj?.platform_id)" v-if="isDelete(shopDetailObj)">
					移除商品
				</el-button>
				<el-button type="primary" @click="refuseFun(shopDetailObj, 2, tabName)" v-if="isRefuse(shopDetailObj)">拒绝带货</el-button>
				<el-button type="primary" @click="beginFun(shopDetailObj, 2, tabName)" v-if="isOkGoods(shopDetailObj)">确认带货</el-button>
				<el-button type="primary" @click="multiFun(shopDetailObj, 4, tabName, shopDetailObj?.platform_id)" v-if="isCheck(shopDetailObj)">
					{{ $isKs(shopDetailObj?.platform_id) ? '校验商品机制' : '校验链接' }}
				</el-button>
				<el-button type="primary" @click="beginFun(shopDetailObj, 1, tabName)" v-if="isBegin(shopDetailObj)">确认开播</el-button>
				<!-- <el-button type="primary" @click="multiFun(shopDetailObj, state)" v-if="false">重新加入选品池</el-button> -->
				<el-button type="primary" @click="multiFun(shopDetailObj, 6, tabName, shopDetailObj?.platform_id)" v-if="isEnd(shopDetailObj)">
					结束合作
				</el-button>
				<el-button type="primary" @click="editProductFun(shopDetailObj, tabName)" v-if="isEdit(shopDetailObj)">修改商品机制</el-button>
				<el-button type="primary" @click="sendGoodsFun(shopDetailObj, tabName)" v-if="isSend(shopDetailObj)">发货</el-button>
				<el-button type="primary" @click="refuseFun(shopDetailObj, 1, tabName)" v-if="isSend(shopDetailObj)">拒绝发货</el-button>
				<el-button type="primary" @click="replaceLinkFun(shopDetailObj, tabName, '上传链接')" v-if="isUpload(shopDetailObj)">上传链接</el-button>
				<el-button type="primary" @click="replaceLinkFun(shopDetailObj, tabName, '更换链接')" v-if="isReplace(shopDetailObj)">更换链接</el-button>
				<el-button type="primary" @click="copyBtnFun(shopDetailObj)" v-if="$isKs(shopDetailObj?.platform_id)">复制商品ID</el-button>
				<el-tooltip class="item" effect="dark" :content="content" :disabled="$isSp(shopDetailObj?.platform_id)" placement="top" v-else>
					<el-button type="primary" @click="copyBtnFun(shopDetailObj)">复制商品链接</el-button>
				</el-tooltip>
			</div>
		</div>
		<handCard-dialog ref="handCardDialog" @refreshList="refreshList"></handCard-dialog>
		<editProduct ref="editProduct" @refreshList="refreshList"></editProduct>
		<sendGood ref="sendGood" @refreshList="refreshList"></sendGood>
		<replaceLink ref="replaceLink" @refreshList="refreshList"></replaceLink>
		<cooperData ref="cooperData" @refreshList="refreshList"></cooperData>
		<refuse ref="refuse" @refreshList="refreshList"></refuse>
		<apply ref="apply" @refreshList="refreshList"></apply>
		<change ref="change" @refreshList="refreshList"></change>
		<multi ref="multi" @refreshList="refreshList"></multi>
		<begin ref="begin" @refreshList="refreshList"></begin>
		<changeDetails ref="changeDetails" @refreshList="refreshList"></changeDetails>
	</div>
</template>
<script>
import mixin from './mixin';
import shopDetails from '@/views/common/shopDetails';
import handCardDialog from '@/views/shopManage/components/handCardDialog.vue';
import editProduct from './components/dialog/editProduct.vue';
import sendGood from './components/dialog/sendGood.vue';
import replaceLink from './components/dialog/replaceLink.vue';
import cooperData from './components/dialog/cooperData.vue';
import refuse from './components/dialog/refuse.vue';
import apply from './components/dialog/apply.vue';
import change from './components/dialog/change.vue';
import multi from './components/dialog/multi.vue';
import begin from './components/dialog/begin.vue';
import changeDetails from './components/dialog/changeDetails.vue';
import { cooperateDetail } from '@/api/cooperationProgress';
import { mapGetters } from 'vuex';
import logistics from './components/dialog/logistics.vue';
import { copyFun } from '@/utils/common';
import {
	productStatus,
	linkStatus,
	promoteStatus,
	cooperationStatus,
	deliveryStatus,
	refuseDelivery,
	affirmStatus,
	changeStatus,
	PLATFORM_KS,
	drRoleType,
} from '@/utils/dataMap';
export default {
	components: {
		shopDetails,
		handCardDialog,
		editProduct,
		sendGood,
		replaceLink,
		cooperData,
		refuse,
		apply,
		change,
		multi,
		begin,
		logistics,
		changeDetails,
	},
	name: 'shopGroup_details',
	mixins: [mixin],
	computed: {
		...mapGetters(['isDarenPartner']),
		drName() {
			return drRoleType.name;
		},
		content() {
			// 保持不变
			return this.isDarenPartner
				? this.shopDetailObj.source_type === '2'
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
	},
	data() {
		return {
			cooperate_id: '',
			shopDetailObj: {},
			selectionShopArr: [],
			tabName: '',
			deliveryInfo: {},
			live_info: {},
			nowState: '',
			productStatus,
			linkStatus,
			promoteStatus,
			cooperationStatus,
			deliveryStatus,
			refuseDelivery,
			changeStatus,
			affirmStatus,
		};
	},
	created() {
		this.tabName = this.$route.query.tabName;
		this.cooperate_id = this.$route.query.cooperate_id;
		this.getCooperateDetail();
	},
	methods: {
		async getCooperateDetail() {
			const { code, data } = await cooperateDetail({ cooperate_id: this.cooperate_id });
			if (code == 0) {
				this.shopDetailObj = data;
				this.deliveryInfo = data.delivery_info;
				this.live_info = data.live_info;
				this.selectionShopArr = [this.shopDetailObj];
			}
		},
		lookHangCard() {
			this.shopDetailObj.hand_card
				? this.$refs.handCardDialog.seeHandCard(this.shopDetailObj)
				: this.$refs.handCardDialog.handCard(this.shopDetailObj);
		},
		refreshList() {
			this.$router.go(0);
		},
		copyBtnFun(row) {
			copyFun(row, this);
		},
		detalis() {
			this.$refs.logistics.logisticsInit(this.shopDetailObj);
		},
	},
};
</script>
<style lang="less" scoped>
.header {
	width: 1000px;
	margin: 0 auto;
}

.footer-btn {
	width: 100%;
	position: fixed;
	bottom: 0;
	left: 0;
	background-color: #fff;
}

.tips {
	height: 40px;
	font-size: 14px;
	background-color: #fef3e7;
}

.cor-FA8F14 {
	color: #fa8f14;
}

.bgc {
	padding: 16px;
	background-color: #f8f8f8;
}

.success {
	color: @color-success;
}

.warning {
	color: @color-warning;
}

.primary {
	color: @color-primary;
	cursor: pointer;
	width: 100px;
	text-align: right;
}

.button {
	border-top: 1px solid #dddddd;

	.el-button {
		margin: 8px 5px;
	}
}
</style>
